import { SxProps, Theme } from "@mui/system";
import { useState } from "react";
import { ImageComponent } from "./imgLoaderStyles";

interface ImgLoaderProps {
  src: string,
  sx?: SxProps<Theme>;
  alt: string
  onLoad?: () => void;
}

export function ImageLoader(props: ImgLoaderProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const { src, sx, alt } = props;

  const onImageLoaded = () => {
    setImageLoaded(true);
    if (props.onLoad) {
      props.onLoad();
    }
  }

  return (
    <ImageComponent
      sx={sx}
      src={src}
      alt={alt}
      imageLoaded={imageLoaded}
      onLoad={onImageLoaded}
    />
  )
}